export const appStoreLink = 'https://apps.apple.com/ao/app/le-gratin/id1529339894';
export const googlePlayLink =
  'https://play.google.com/store/apps/details?id=io.ambroselli.legratin';
